import { useMutation, useQuery } from 'react-query';
import myImagesApi from '../apis/myimages';

const {
  fetchMyGeneratedImages,
  fetchMyGeneratedImagesByDate,
  downloadImageByDate,
  downloadImageManualEditingByDate,
} = myImagesApi;

export const useGetMyGeneratedImages = (
  remark,
  pageNum,
  pageSize,
  searchText,
  timeZone,
  type,
  date,
  onSuccess,
  onError,
  refetchOnWindowFocus = false
) =>
  useQuery(
    ['' + remark, pageNum, pageSize, searchText, timeZone, type],
    () => fetchMyGeneratedImages(pageNum, pageSize, searchText, timeZone, type),
    {
      onSuccess,
      onError,
    }
  );

export const useGetMyGeneratedImagesByDate = (
  remark,
  pageNum,
  pageSize,
  searchText,
  timeZone,
  type,
  date,
  onSuccess,
  onError
) =>
  useQuery(
    ['' + remark, pageNum, pageSize, searchText, timeZone, type, date],
    () =>
      fetchMyGeneratedImagesByDate(
        pageNum,
        pageSize,
        searchText,
        timeZone,
        type,
        date
      ),
    {
      onSuccess,
      onError,
      enabled: !!date,
    }
  );

export const useDownloadImagesByDate = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      console.log(payload);
      return downloadImageByDate(payload);
    },
    onSuccess,
    onError,
  });
};

export const useDownloadImagesByDateManualEditing = (onSuccess, onError) => {
  return useMutation({
    mutationFn: (payload) => {
      console.log(payload);
      return downloadImageManualEditingByDate(payload);
    },
    onSuccess,
    onError,
  });
};
